import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@material-ui/core'
import { logOut } from '../../utils/Authentication'
import { goToUrl } from '../../utils/UrlManipulation'

const LogoutButton = () => {
    const { t } = useTranslation()
    return <Button variant="contained" color="primary" onClick={
        () => {
            logOut()
            goToUrl("/login")
        }
    }>
        {t('authentication.logout')}
    </Button>
}

export default LogoutButton